import { toast } from 'sonner';
import type { IntegrityCheckResult, IntegrityNotification } from '../../types/index';

export function buildIntegrityNotifications(
  institutionName: string,
  institutionId: string,
  checks: IntegrityCheckResult[]
): IntegrityNotification[] {
  const notifications: IntegrityNotification[] = [];

  // Group checks by severity
  const failures = checks.filter(c => c.status === 'FAIL');
  const warnings = checks.filter(c => c.status === 'WARNING');

  if (failures.length > 0) {
    notifications.push({
      type: 'error',
      title: `Data Issues Detected`,
      message: `${institutionName}: ${failures.length} critical data integrity issues found`,
      details: failures.map(f => `${f.check_name}: ${f.issues_count} issues`),
      actionable: failures.some(f => f.auto_fixable),
      institutionId,
      timestamp: new Date().toISOString()
    });
  }

  if (warnings.length > 0) {
    notifications.push({
      type: 'warning',
      title: `Data Quality Warnings`,
      message: `${institutionName}: ${warnings.length} data quality warnings`,
      details: warnings.map(w => `${w.check_name}: ${w.issues_count} items`),
      actionable: warnings.some(w => w.auto_fixable),
      institutionId,
      timestamp: new Date().toISOString()
    });
  }

  return notifications;
}

export function emitIntegrityToasts(
  notifications: IntegrityNotification[],
  autoCleanupPerformed: boolean
) {
  notifications.forEach(notification => {
    if (notification.type === 'error') {
      toast.error(notification.title, {
        description: notification.message,
        duration: 8000
      });
    } else if (notification.type === 'warning') {
      toast.warning(notification.title, {
        description: notification.message,
        duration: 6000
      });
    } else if (notification.type === 'success' && autoCleanupPerformed) {
      toast.success(notification.title, {
        description: notification.message,
        duration: 4000
      });
    }
  });
}
